export default __webpack_public_path__ + "7616d9f7c80baac641dd72b46c4ec91d.png";